/**
 *
 * @param arg image url
 * @description supply safe way to import image from assets folder
 * @returns
 */
function safeImageImport(arg: string) {
  // const webpImage = tryRequire('../../' + arg + '.webp');
  let webpImage: any;
  try {
    webpImage = require('../../' + arg + '.webp');
  } catch (e) {}
  if (webpImage) {
    return webpImage;
  }

  // const jpgImage = tryRequire('../../' + arg + '.jpg');
  let jpgImage: any;
  try {
    jpgImage = require('../../' + arg + '.jpg');
  } catch (e) {}
  if (jpgImage) {
    return jpgImage;
  }

  // const pngImage = tryRequire('../../' + arg + '.png');
  let pngImage: any;
  try {
    pngImage = require('../../' + arg + '.png');
  } catch (e) {}
  if (pngImage) {
    return pngImage;
  }

  return null;
}

export { safeImageImport };
